var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"confirmOrder"}},[_c('div',[_c('h1',[_vm._v("Pedido registrado exitósamente")]),_vm._v(" "),_c('p',[_vm._v("\n      Recibirás un link de pago en tu teléfono para completar la operación!\n    ")]),_vm._v(" "),_c('p',[_vm._v("Gracias!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12248f9e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ConfirmOrder.vue
// module id = 447
// module chunks = 0